import { render, staticRenderFns } from "./MediaFileField.vue?vue&type=template&id=0ab1946a&scoped=true&"
import script from "./MediaFileField.vue?vue&type=script&lang=js&"
export * from "./MediaFileField.vue?vue&type=script&lang=js&"
import style0 from "./MediaFileField.vue?vue&type=style&index=0&id=0ab1946a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab1946a",
  null
  
)

export default component.exports